import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const ContactEventParts = [
  'container',
  'dateText',
  'typeContainer',
  'typeIcon',
  'typeText',
  'numbersContainer',
  'fromNumberText',
  'arrowIcon',
  'toNumberText',
] as const

const helpers = createMultiStyleConfigHelpers(ContactEventParts)

export const ContactEventStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      flexDirection: 'column',
      height: '7.5rem',
      marginTop: '-0.1rem',
      paddingX: '0.75rem',
      gap: '0.25rem',
    },
    dateText: {
      ...textStyles[textStyleKeys.Body2_Bold],
    },
    typeContainer: {
      alignItems: 'center',
      gap: '0.25rem',
    },
    typeIcon: {
      boxSize: '1rem',
    },
    typeText: {
      ...textStyles[textStyleKeys.Body2],
    },
    numbersContainer: {
      align: 'center',
      gap: '0.5rem',
    },
    fromNumberText: {
      ...textStyles[textStyleKeys.Body2],
    },
    arrowIcon: {
      boxSize: '0.75rem',
      mt: '0.28rem',
    },
    toNumberText: {
      ...textStyles[textStyleKeys.Body2],
    },
  },
})

export const useContactEventStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(ContactEventStyle, props) as MultiStyleType<
    typeof ContactEventParts
  >
}
